"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubscriptionOrderTypeCreate = exports.useSubscriptionOrderTypeFetch = void 0;
const react_redux_1 = require("react-redux");
const subsOrderTypeAction_1 = require("./subsOrderTypeAction");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const react_router_dom_1 = require("react-router-dom");
function useSubscriptionOrderTypeFetch() {
    const history = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const subsOrderTypeLoading = (0, react_redux_1.useSelector)((state) => state['subscriptionPurchaseOrderType/fetch'].loading);
    const subsOrderTypeData = (0, react_redux_1.useSelector)((state) => state['subscriptionPurchaseOrderType/fetch'].data);
    const subsOrderTypeError = (0, react_redux_1.useSelector)((state) => state['subscriptionPurchaseOrderType/fetch'].error);
    const fetchSubscriptionOrderType = () => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, subsOrderTypeAction_1.fetch)());
    });
    return { fetchSubscriptionOrderType, subsOrderTypeLoading, subsOrderTypeData, subsOrderTypeError };
}
exports.useSubscriptionOrderTypeFetch = useSubscriptionOrderTypeFetch;
function useSubscriptionOrderTypeCreate() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const subsOrderTypeCreateLoading = (0, react_redux_1.useSelector)((state) => state['subscriptionPurchaseOrderType/create'].loading);
    const subsOrderTypeCreateData = (0, react_redux_1.useSelector)((state) => state['subscriptionPurchaseOrderType/create'].data);
    const subsOrderTypeCreateError = (0, react_redux_1.useSelector)((state) => state['subscriptionPurchaseOrderType/create'].error);
    const createSubscriptionOrderType = (payload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, subsOrderTypeAction_1.create)(payload));
    });
    return { createSubscriptionOrderType, subsOrderTypeCreateLoading, subsOrderTypeCreateData, subsOrderTypeCreateError };
}
exports.useSubscriptionOrderTypeCreate = useSubscriptionOrderTypeCreate;
